export default [
  {
    path: '/auth/users',
    name: 'users',
    component: () =>
      import(/* webpackChunkName: "users" */
        /* webpackMode: "lazy" */
        `./views/User/UserList.vue`)
  },
  {
    path: '/auth/my-account',
    name: 'my-account',
    component: () =>
      import(/* webpackChunkName: "my_account" */
        /* webpackMode: "lazy" */
        `./views/User/MyAccount.vue`)
  },
  {
    path: '/auth/users/:id',
    name: 'single_user',
    component: () =>
      import(/* webpackChunkName: "users" */
        /* webpackMode: "lazy" */
        `./views/User/UserSingle.vue`)
  },
  {
    path: '/auth/roles',
    name: 'roles',
    component: () =>
      import(/* webpackChunkName: "roles" */
        /* webpackMode: "lazy" */
        `./views/Role/RoleList.vue`)
  },
  {
    path: '/auth/roles/:id',
    name: 'single_role',
    component: () =>
      import(/* webpackChunkName: "roles" */
        /* webpackMode: "lazy" */
        `./views/Role/RoleSingle.vue`)
  },
  {
    path: '/auth/permissions',
    name: 'permissions',
    component: () =>
      import(/* webpackChunkName: "permissions" */
        /* webpackMode: "lazy" */
        `./views/Permission/PermissionList.vue`)
  },
  {
    path: '/auth/permissions/:id',
    name: 'single_permission',
    component: () =>
      import(/* webpackChunkName: "permissions" */
        /* webpackMode: "lazy" */
        `./views/Permission/PermissionSingle.vue`)
  },
  {
    path: '/auth/terms',
    name: 'tos',
    component: () =>
      import(/* webpackChunkName: "roles" */
        /* webpackMode: "lazy" */
        `./views/ToS.vue`)
  }
]
